import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ProjectDetail from '@/components/ProjectDetail.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDetailView',
  setup(__props) {

const route = useRoute();

// Compute the numeric projectId by converting the route param to a number
const projectId = computed(() => {
  const id = route.params.id as string;
  const parsedId = Number(id);
  if (isNaN(parsedId)) {
    throw new Error('Invalid project ID');
  }
  return parsedId;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProjectDetail, { id: projectId.value }, null, 8, ["id"])
  ]))
}
}

})